// tslint:disable
export enum AccountStatus {
    /**
     * @description UNKNOWN
     */
    UNKNOWN = 0,
    /**
     * @description ACTIVE
     */
    ACTIVE = 1,
    /**
     * @description INACTIVE
     */
    INACTIVE = 2,
    /**
     * @description REDACTED
     */
    REDACTED = 3,
}
